import { DefaultPage, EditEvent, CreateEvent } from './';

export default {
  path: 'events/:version/v',
  name: 'Events',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/event/:eventId',
      name: 'Edit event',
      component: EditEvent,
      isPrivate: true,
    },
    { path: ':projectId/create', name: 'Create event', component: CreateEvent, isPrivate: true },
  ],
};
